import { Text, View } from "@react-pdf/renderer";
import React from "react";

import { sectionStyles } from "../styles";

interface IOverallAISummarySectionProps {
  title: string;
  aiSummary: string | undefined;
}

export const OverallAISummarySection: React.FunctionComponent<
  IOverallAISummarySectionProps
> = ({ title, aiSummary }) => {
  return (
    <View style={sectionStyles.container}>
      <Text style={sectionStyles.title}>{title}</Text>
      <View style={sectionStyles.divider} />
      {aiSummary ? (
        <Text style={sectionStyles.summaryText}>{aiSummary}</Text>
      ) : (
        <Text style={sectionStyles.noData}>—</Text>
      )}
    </View>
  );
};
